import { Route, Schedule } from "tm-shared/types";

import { RouteEditorFormValues } from "./components/RouteEditorForm";

export enum RouteEditorModal {
    EditSchedule = "editSchedule",
    MoveSchedule = "moveSchedule",
    WarningDebt = "warningDebt",
    DeleteSchedule = "deleteSchedule",
}

export interface RouteEditorEditLocationState {
    formValues: RouteEditorFormValues;
    isDeleteBlocked: boolean;
}

export type RouteEditorModalPayloads = {
    [RouteEditorModal.EditSchedule]:
        | { createMode: true; schedule: Schedule }
        | {
              createMode: false;
              schedule: Schedule;
              route: Route;
              allSchedules: Schedule[];
          };

    [RouteEditorModal.MoveSchedule]: {
        pointIds: string[];
        currentRouteId: string;
    };

    [RouteEditorModal.WarningDebt]: {
        isMultiSelect: boolean;
    };

    [RouteEditorModal.DeleteSchedule]:
        | {
              createMode: true;
              isEmptyAfterDelete: boolean;
              pointIds: string[];
          }
        | {
              createMode: false;
              isEmptyAfterDelete: boolean;
              pointIds: string[];
              currentRouteId: string;
          };
};

export type RouteEditorModalState =
    | {
          type: RouteEditorModal.EditSchedule;
          payload: RouteEditorModalPayloads[RouteEditorModal.EditSchedule];
      }
    | {
          type: RouteEditorModal.MoveSchedule;
          payload: RouteEditorModalPayloads[RouteEditorModal.MoveSchedule];
      }
    | {
          type: RouteEditorModal.WarningDebt;
          payload: RouteEditorModalPayloads[RouteEditorModal.WarningDebt];
      }
    | {
          type: RouteEditorModal.DeleteSchedule;
          payload: RouteEditorModalPayloads[RouteEditorModal.DeleteSchedule];
      }
    | null;
